import checkout from "./form";

const {
  formField: {
    taxpayers,
    taxCode,
    taxAgentName,
    taxAgentCode,

    company,
    unitCompany,
    from,
    firstTime,
    mst,
    strangeFrom,
    strangeTo,
    time,

    chiefAccountant,
    certificateNumber,
    unitHeads,
    dateFounded,
  },
} = checkout;

const initialValues = {
  [taxpayers.name]: "",
  [taxCode.name]: "",
  [taxAgentName.name]: "",
  [taxAgentCode.name]: "",

  [company.name]: false,
  [unitCompany.name]: false,
  [from.name]: "",
  [firstTime.name]: false,
  [mst.name]: "",
  [strangeFrom.name]: "",
  [strangeTo.name]: "",
  [time.name]: "",

  [chiefAccountant.name]: "",
  [certificateNumber.name]: "",
  [unitHeads.name]: "",
  [dateFounded.name]: "",
};

export default initialValues;
